import * as Yup from 'yup';

export const FaqValidationSchema = Yup.object({
  question: Yup.string()
    .trim()
    .required('Question is required')
    .max(200, 'Maximum 200 characters'),
  answer: Yup.string()
    .trim()
    .required('Answer is required')
    .max(400, 'Maximum 400 characters'),
  isActive: Yup.string().trim().required('Status is required'),
  displayOrder: Yup.number()
    .required('Display Order is required')
    .integer('Must be an integer')
    .positive('Must be a positive number'),
});
